export default {
  title01: "الطقس الحالي",
  title02: "24 ساعة",
  title03: "عرض توقعات الطقس لمدة 10 أيام",
  title04: "مؤشر جودة الهواء",
  title05: "عرض جميع المعلومات",
  title06: "شروق وغروب الشمس",
  title07: "مراحل القمر",
  title08: "القمر الكامل القادم",
  title09: "القمر الجديد القادم",
  title10: "النهار",
  title11: "الليل",
  title12: "شروق الشمس",
  title13: "غروب الشمس",
  title14: "شروق القمر",
  title15: "غروب القمر",
  title16: "المصدر",
  title17: "البداية",
  title18: "النهاية",
  title19: "استخدام الموقع الحالي",
  title20: "البحث عن المدينة",
  title21: "درجة الحرارة المحسوسة",
  title22: "درجة الحرارة المحسوسة في الظل",
  title23: "الآن",
  title24: "اليوم",
  title25: "الأحد",
  title26: "الاثنين",
  title27: "الثلاثاء",
  title28: "الأربعاء",
  title29: "الخميس",
  title30: "الجمعة",
  title31: "السبت",
  title32: "...جارٍ التحميل",
  title33: "الآن",
  title34: "كل ساعة",
  title35: "يوميًا",
  title36: "الشمس والقمر",
  title37: "جودة الهواء",
  title38: "للتواصل: xlf550402@gmail.com",
  title39: "اتفاقية الخصوصية",
  title40: "حقوق النشر © comfortweather.com 2020 - 2025. جميع الحقوق محفوظة.",
  title41: "البيانات مقدمة من",
  title42: "درجة الحرارة الكبرى",
  title43: "درجة الحرارة الصغرى",
  title44: "قبول",
  title45: "شكرًا لك على استخدام ComfortWeather! لحماية حقوقك ومصالحك القانونية بشكل أفضل، يُرجى قراءة ",
  title46: "سياسة الخصوصية",
  title47: " بعناية قبل الاستخدام.",
  title48: "",
  title49: "للتواصل: xyjph123@gmail.com",
  title50: "حقوق النشر © 24hweather.com 2020 - 2025. جميع الحقوق محفوظة.",
  title51: "شكرًا لك على استخدام 24hweather! لحماية حقوقك ومصالحك القانونية بشكل أفضل، يُرجى قراءة ",
};
